import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title:
    '<mark>Activate</mark> your account by entering the <mark>code</mark> sent to your email',
  code: 'Code',
  codePlaceholder: '123456',
  submit: 'Activate account',
  didntGetACode: 'Didn’t get the code? Retry now!',
};

const welsh = {
  title: "Gweithredwch eich cyfrif trwy nodi'r cod a anfonwyd i'ch e-bost",
  code: 'Cod',
  codePlaceholder: '123456',
  submit: 'Gweithredu cyfrif',
  didntGetACode: 'Heb dderbyn y cod? Ailadrodd nawr!',
};

export const confirmEmailText: any = getLocalizationBasedOnLang(english, welsh);
